
$(document).on('click', '.bundle_remove', function(){
    alert('clicked');
    var parentBundleKey = $(this).closest('.cart-item').find('.cart-item__property[bundle="Bundle_key_parent"]').attr('bundlekey');
    var mainitemRemoveBtn = $(this).next();
    alert(parentBundleKey);
    var itemid = [];
    $('.cart-item__property[bundle="Bundle_key_child"]').each(function(){
        var childBundleKey = $(this).attr('bundlekey');
        var itemKey = $(this).attr('itemkey');
        if(parentBundleKey==childBundleKey){
            itemid.push(itemKey);
           
           
        }
        
    })
    console.log(itemid);

    var updates = {};

    $.each(itemid, function(index, key) {
        updates[key] = 0;
    });

    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: updates
        },
        success: function(res) {
            console.log('All items removed', res);
            $(mainitemRemoveBtn).trigger('click');
        },
        error: function(err) {
            console.log('Error removing items', err);
        }
    });
})